import i18next from "i18next";
import { IoReturnDownBack } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../context/auth";
import { checkIsAllowedRefundRequest } from "../../../utils";

import { RefundButton, Wrapper } from "./style";

// Кнопка «Заявка на возврат» на странице заказа (рядом с отменой): только для выписанного заказа.
// Гостю (заказ найден через поиск по email) в ссылку передаём и email плательщика — форма заполнится сама.
const OrderRefundRequestComponent = ({ isShowInSmallScreen = false }) => {
  const { t } = i18next;
  const navigate = useNavigate();
  const { isAuth } = useAuth();
  const {
    orderData: { order_id, booking_status, order_status, payer_email, session_id },
  } = useSelector(state => state.order);

  if (!checkIsAllowedRefundRequest(booking_status, order_status)) return null;

  const handleClick = () => {
    const params = new URLSearchParams({ order_id });
    // сессия заказа — форма по ней загрузит пассажиров и даст выбрать, кого возвращать
    if (session_id) params.set("session", session_id);
    if (!isAuth && payer_email) params.set("payer_email", payer_email);
    navigate(`/refund-request?${params.toString()}`);
  };

  return (
    <Wrapper $isShowInSmallScreen={isShowInSmallScreen}>
      <RefundButton type="button" onClick={handleClick}>
        <IoReturnDownBack />
        {t("request_refund")}
      </RefundButton>
    </Wrapper>
  );
};

export default OrderRefundRequestComponent;
